<script>
import { SiteSettings } from '@/api/'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'
import { cloneDeep } from 'lodash'

export default {
  components: {},
  mixins: [FormMixin],
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.service.get().then(response => {
        this.form = response.data
        this.prepareFormCopyToPreventChangesLost()
      })
    },
    onSubmit() {
      this.loading = true
      const service = this.service.update(this.form)
      service
        .then(this.successHandler)
        .then(() => {
          this.formCopy = cloneDeep(this.form)
        })
        .catch(this.errorHandler)
    },
    getFields() {
      return [
        {
          component: 'el-tabs',
          children: [this.getGeneralTab(), this.getNewsletterTab()]
        }
      ]
    },
    getGeneralTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'Ogólne'
        },
        children: [
          new fields.Input({
            label: 'Link do facebooka',
            modelPath: [this, 'form', 'facebook_url']
          }),
          new fields.Input({
            label: 'Link do twittera',
            modelPath: [this, 'form', 'twitter_url']
          }),
          new fields.Input({
            label: 'Link do instagrama',
            modelPath: [this, 'form', 'instagram_url']
          }),
          new fields.Attachment({
            label: 'Logo (svg)',
            modelPath: [this, 'form', 'logo'],
            accept: '.svg'
          }),
          new fields.Link({
            label: 'Link do polityki prywatności',
            modelPath: [this, 'form', 'privacy_policy_link']
          })
        ]
      }
    },
    getNewsletterTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'Newsletter'
        },
        children: [
          new fields.Header({
            text:
              'UWAGA: Zmiany w tej zakładce spowodują zaktualizowanie wszystkich widgetów z newsletterami.',
            type: 'h4'
          }),
          new fields.Input({
            label: 'Tytuł',
            modelPath: [this, 'form', 'newsletter', 'title'],
            multilingual: true
          }),
          new fields.WYSIWYG({
            label: 'Tekst',
            modelPath: [this, 'form', 'newsletter', 'text'],
            multilingual: true
          }),
          new fields.Input({
            label: 'Tekst przycisku',
            modelPath: [this, 'form', 'newsletter', 'button_text'],
            multilingual: true
          }),
          new fields.Input({
            label: 'Tekst podpowiedzi',
            modelPath: [this, 'form', 'newsletter', 'input_placeholder'],
            multilingual: true
          }),
          new fields.WYSIWYG({
            label: 'Tekst przy zgodzie',
            modelPath: [this, 'form', 'newsletter', 'agreement_text'],
            multilingual: true
          })
        ]
      }
    }
  },
  computed: {
    service() {
      return SiteSettings
    }
  }
}
</script>
